import initialState from './BrandsInitialState';
import reducers from './BrandsReducer';

export default {
  initialState,
  reducers,
};
